export const QualityOversight = () => {
  const errorPatterns = [
    { name: "Incorrect VAT Code", percentage: 65, color: "bg-brand-danger" },
    { name: "Missing Invoice Number", percentage: 20, color: "bg-brand-warning" },
    { name: "Duplicate Entry", percentage: 10, color: "bg-brand-text-secondary" },
    { name: "Other", percentage: 5, color: "bg-gray-300" }
  ];

  return (
    <div className="bg-white p-6 rounded-2xl border border-brand-border">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-brand-primary">Quality Oversight</h3>
        <button className="p-1.5 text-brand-text-secondary">
          <i className="fa-solid fa-ellipsis"></i>
        </button>
      </div>
      
      <div className="space-y-4">
        <p className="text-xs text-brand-text-secondary mb-2">Most Common Error Patterns:</p>
        
        {errorPatterns.map((pattern) => (
          <div key={pattern.name} className="flex items-center justify-between text-xs">
            <span className="flex-1">{pattern.name}</span>
            <div className="w-1/2 bg-gray-200 rounded-full h-2 mx-2">
              <div 
                className={`${pattern.color} h-2 rounded-full`}
                style={{ width: `${pattern.percentage}%` }}
              ></div>
            </div>
            <span className="font-medium w-8 text-right">{pattern.percentage}%</span>
          </div>
        ))}
      </div>
      
      <div className="mt-6 pt-4 border-t border-brand-border">
        <p className="text-xs text-brand-text-secondary mb-3">Improvement Opportunities:</p>
        <div className="flex items-start gap-3 p-3 bg-brand-secondary rounded-xl">
          <i className="fa-solid fa-lightbulb text-brand-primary mt-1"></i>
          <p className="text-xs text-brand-text-primary">
            Consider creating an automated rule for recurring "Innovate Zurich" invoices to reduce manual VAT code errors.
          </p>
        </div>
      </div>
    </div>
  );
};